import React from "react";
import Radio from "@front_office/components/payment/Radio";
import Helper from "@/helper.js";
import InfoTooltip from '@front_office/components/common/InfoTooltip';

import translator from "@/translator";
const t = translator("front_office.views.payments.variants.whatsapp.");

const PaymentRadios = ({ list, setValue, currency, lastMonthAndNotEnoughMoney }) =>
list.map((opt) => (
    <div key={opt.sum} className="payment-radio-container">
      <Radio
        key={opt.sum}
        title={
          <div className="radio-title-with-info" dangerouslySetInnerHTML={{ __html: opt.translation }} />
        }
        label={
          !lastMonthAndNotEnoughMoney && opt.discount_percent > 0 &&
          t("payment_radio_discount", { discount_percent: opt.discount_percent })
        }
        name={"payment_radio_sum"}
        value={opt.sum}
        onClick={() => {
          setValue("payment_sum", opt.sum);
          setValue("period", opt.period);
          setValue("translation", opt.translation);
          setValue("skip_renew_sub", opt.skip_renew_sub);
        }}
        content={
          <>
            <div className="price-line">
              {t("payment_radio_label")}{" "}
              {opt.discount_percent > 0 && (
                <span className="full_price">
                  {Helper.formatMoney(opt.sum_without_discount, currency)}
                </span>
              )}{" "}
              <b className="actual_price">{Helper.formatMoney(opt.sum, currency)}</b>
            </div>
            {lastMonthAndNotEnoughMoney && opt.discount_percent > 0 && (
              <div className="discount-label">
                {t("payment_radio_discount", { discount_percent: opt.discount_percent })}
              </div>
            )}
          </>
        }
      />
      {(lastMonthAndNotEnoughMoney && opt.period > 1) && (
        <div className="info-icon-corner">
          <InfoTooltip
            title={t("info_tooltip_text")}
          />
        </div>
      )}
    </div>
  ));

export default PaymentRadios;
